"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _components = require("./components");
var _utils = require("./lib/utils");
var _states = require("./lib/constants/states");
const propTypes = {
  availability: _propTypes.array,
  messages: (0, _propTypes.shape)({
    moreAvailabilitiesLinkText: _propTypes.node.isRequired
  }).isRequired,
  providerId: _propTypes.number.isRequired,
  maxAvailabilitiesToDisplay: _propTypes.number.isRequired,
  currentState: (0, _propTypes.shape)({
    context: (0, _propTypes.shape)({
      apptInfo: (0, _propTypes.shape)({
        relationship: _propTypes.string.isRequired,
        purpose: _propTypes.string.isRequired
      }),
      provider: (0, _propTypes.shape)({
        book_online_url: _propTypes.string.isRequired
      })
    }),
    matches: _propTypes.func.isRequired
  }),
  availabilityLinkTarget: _propTypes.string
};

/**
 * @deprecated Use VisibleAvailabilityTiles
 */
function ProfileAvailabilityTiles(_ref) {
  let {
    availability,
    providerId,
    maxAvailabilitiesToDisplay,
    messages,
    currentState,
    availabilityLinkTarget
  } = _ref;
  const {
    moreAvailabilitiesLinkText
  } = messages;
  if (currentState.matches(_states.idle) || currentState.matches(_states.pending)) {
    return /*#__PURE__*/_react.default.createElement(_components.LoadingAvailabilityTiles, {
      maxAvailabilitiesToDisplay: maxAvailabilitiesToDisplay,
      shouldDisplayAsOnMobile: true
    });
  }
  if (currentState.matches(_states.success)) {
    const bookOnlineUrl = currentState.context.provider.book_online_url;
    const availabilities = (0, _utils.oldFormatAvailabilityForTiles)(availability, bookOnlineUrl);
    return /*#__PURE__*/_react.default.createElement(_components.VisibleAvailabilityTiles, {
      availabilities: availabilities,
      maxAvailabilitiesToDisplay: maxAvailabilitiesToDisplay,
      displayLinkToViewMoreAvailabilities: true,
      moreAvailabilitiesLinkText: moreAvailabilitiesLinkText,
      viewMoreBookOnlineUrl: currentState.context.apptInfo ? (0, _utils.createBookingDeepLink)({
        ...currentState.context.apptInfo,
        providerId
      }) : '',
      providerId: providerId,
      shouldDisplayAsOnMobile: true,
      linkTarget: availabilityLinkTarget
    });
  }
}
ProfileAvailabilityTiles.propTypes = propTypes;
var _default = exports.default = ProfileAvailabilityTiles;
ProfileAvailabilityTiles.__docgenInfo = {
  "description": "@deprecated Use VisibleAvailabilityTiles",
  "methods": [],
  "displayName": "ProfileAvailabilityTiles",
  "props": {
    "availability": {
      "description": "",
      "type": {
        "name": "array"
      },
      "required": false
    },
    "messages": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "moreAvailabilitiesLinkText": {
            "name": "node",
            "required": true
          }
        }
      },
      "required": true
    },
    "providerId": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "maxAvailabilitiesToDisplay": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "currentState": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "context": {
            "name": "shape",
            "value": {
              "apptInfo": {
                "name": "shape",
                "value": {
                  "relationship": {
                    "name": "string",
                    "required": true
                  },
                  "purpose": {
                    "name": "string",
                    "required": true
                  }
                },
                "required": false
              },
              "provider": {
                "name": "shape",
                "value": {
                  "book_online_url": {
                    "name": "string",
                    "required": true
                  }
                },
                "required": false
              }
            },
            "required": false
          },
          "matches": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": false
    },
    "availabilityLinkTarget": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};